export default {
    //statement overview
    "xls-statement-overview-sheet-name": "Overview-%accountDescription%",
    "xls-statement-overview-label-start-date": "Start date",
    "xls-statement-overview-label-end-date": "End date",
    "xls-statement-overview-label-plan-type": "Plan Type",
    "xls-statement-overview-label-termination-date": "Termination Date",
    "xls-statement-overview-label-grace-period-end-date": "Grace Period End Date",
    "xls-statement-overview-label-claims-filing-deadline": "Claims filing deadline",
    "xls-statement-overview-value-months-from-claim": "months from date of claim",
    "xls-statement-overview-label-threshold": "Threshold",
    "xls-statement-overview-label-accumulation-amount": "Accumulation Amount",
    "xls-statement-overview-label-beginning-balance": "Beginning Balance as of %startDate%",
    "xls-statement-overview-label-rollover-from-prior-year": "Rollover from Prior Year",
    "xls-statement-overview-label-contributions-current": "Current Tax Year Contributions",
    "xls-statement-overview-label-contributions-prior": "Prior Tax Year Contributions",
    "xls-statement-overview-label-election-amount": "Election Amount",
    "xls-statement-overview-label-employer-funding": "Employer Funding",
    "xls-statement-overview-label-contributions": "Contributions",
    "xls-statement-overview-label-other-transfers": "Other Transfers",
    "xls-statement-overview-label-investment-transfers": "Investment Account Transfers",
    "xls-statement-overview-label-interest-earned": "Interest Earned",
    "xls-statement-overview-label-withdrawals": "Withdrawals",
    "xls-statement-overview-label-fees": "Fees",
    "xls-statement-overview-label-available-balance": "Available Balance",

    //statement details
    "xls-statement-details-sheet-name": "Details",
    "xls-statement-details-header-posted-date": "Posted Date",
    "xls-statement-details-header-tax-year": "Tax Year",
    "xls-statement-details-header-category": "Category",
    "xls-statement-details-header-description": "Description",
    "xls-statement-details-header-amount": "Amount",
    "xls-statement-details-category-accumulation": "Accumulation",
    "xls-statement-details-category-contribution": "Contribution",
    "xls-statement-details-category-transfer": "Transfer",
    "xls-statement-details-category-investment-transfer": "Investment Transfer",
    "xls-statement-details-category-interest": "Interest",
    "xls-statement-details-category-claim": "Claim",
    "xls-statement-details-category-fee": "Fee Withdrawal",

    //transactions
    "xls-transactions-sheet-name": "Activity-%accountDescription%",
    "xls-transactions-header-posted-date": "Posted Date",
    "xls-transactions-header-type": "Type",
    "xls-transactions-header-description": "Description",
    "xls-transactions-header-amount": "Amount",
    "xls-transactions-header-service-from": "Service From",
    "xls-transactions-header-service-to": "Service To",
    "xls-transactions-header-action-required": "Action Required",
    "xls-transactions-header-has-attachment": "Has Attachment",
    "xls-transactions-header-note": "Note",
}